import { BarChart } from '../../../components/Charts';
import { useRef, useEffect, useMemo, useCallback, useState } from 'react';
import dayjs from 'dayjs';
import { useSetUpList } from '../../../hooks/queries/setUpQueries';
const DrResourceBarChart = ({ data, metaData }) => {
  const { data: setUpData } = useSetUpList();
  const defaultChargingDemandPredictionModuleName = setUpData?.Items?.find(item => item.Group === 'ChargingDemandAi' && item.Key === 'CHARGING_DEMAND_AI_NAME')?.Value;
  const defaultChargingDemandPredictionModuleVersion = setUpData?.Items?.find(item => item.Group === 'ChargingDemandAi' && item.Key === 'CHARGING_DEMAND_AI_VERSION')?.Value;

  const fromDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
  const toDate = dayjs().format('YYYY-MM-DD');

  const moduleName = defaultChargingDemandPredictionModuleName;
  const moduleVersion = defaultChargingDemandPredictionModuleVersion;

  const [cssColors, setCssColors] = useState({
    gray600: '#718096',
    graphSetZ1: '#8C62FF',
    graphSetZ2: '#FB85A1',
    graphSetZ3: '#38BDF8',
    graphSetZ4: '#FEC02E',
  });

  useEffect(() => {
    const getCSSVariable = (variable) => {
      return getComputedStyle(document.documentElement)
        .getPropertyValue(variable)
        .trim();
    };
    setCssColors({
      gray600: getCSSVariable('--gray-600'),
      graphSetZ1: getCSSVariable('--graph-set-z1'),
      graphSetZ2: getCSSVariable('--graph-set-z2'),
      graphSetZ3: getCSSVariable('--graph-set-z3'),
      graphSetZ4: getCSSVariable('--graph-set-z4'),
    });
  }, []);

  const transformPredictionChargingDemandData = useCallback((data) => {
    // x축 라벨 생성: 7일 전부터 오늘까지 총 7개의 날짜 (고정)
    const labels = [];
    const chartData = [];
    
    // 7일 전부터 오늘까지 날짜 배열 생성
    for (let i = 6; i >= 0; i--) {
      const date = dayjs().subtract(i, 'day');
      const dateStr = date.format('YYYY-MM-DD');
      labels.push(dateStr);
      
      // API 데이터에서 해당 날짜 찾기
      const matchingItem = data?.Items?.find(item => {
        // RecordDate에서 T 이후 제외 (날짜만 추출)
        const recordDate = item.RecordDate ? item.RecordDate.split('T')[0] : null;
        return recordDate === dateStr;
      });
      
      // 매칭되는 데이터가 있으면 PredictedChargingDemand 사용, 없으면 0
      const value = matchingItem?.PredictedChargingDemand ? (matchingItem?.PredictedChargingDemand/1000).toFixed(2) : 0;
      chartData.push(value);
    }
    
    return {
      labels: labels,
      datasets: [
        {
          label: '일일 충전량 예측값 (kWh)',
          data: chartData,
          backgroundColor: cssColors.graphSetZ4,
        }
      ]
    };
  }, []);
  
  const chartData = useMemo(() => {
    return transformPredictionChargingDemandData(data);
  }, [data, transformPredictionChargingDemandData]);

  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
  }, [chartData]);
  return (
    <BarChart data={chartData} showDataLabels={true} />
  );
};

export default DrResourceBarChart;